import { useQuery } from "@tanstack/react-query";
import { getParticipants } from "api/account";

export const useParticipants = (id: string) => {

	return useQuery({
        queryKey: ['participants', id],
		queryFn: () =>  getParticipants(id),
	});
};